import memoizeOne from 'react-utils/memoizeOne';
import { getProjectName } from '../../../common/utils';
export const getInitialProps = memoizeOne(() => {
  const hostAppName = getProjectName();
  return {
    hostAppName,
    modalKey: ''
  };
});